export default {
  label: {
    en: 'Get free {gender, select, female {perfume} male {cologne}}',
  },
}
